import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { PollieRater } from './PollieRater'

export const PollieRaterRegistration = createRegisterableComponent(
    'pollie-rater-listing',
    () => {
        return <PollieRater />
    },
)
